import { StyleSheet, View } from 'react-native';
import { ChildrenWithProps } from '@ui-kitten/components/devsupport';

import { Menu } from '../../Menu';
import { ModalBackdrop, ModalBackdropProps } from '../../Modal';
import { ModalMenuItemProps } from '../MenuItem';
import { spacing } from '../../../theme';

export const MenuContainer = ({
	visible,
	onBackdropPress,
	children,
	bottom,
}: MenuContainerProps) => {
	return (
		<ModalBackdrop onPress={onBackdropPress} visible={visible}>
			<View style={[styles.menuContainer, bottom && styles.bottom]}>
				<Menu style={styles.menu}>{children}</Menu>
			</View>
		</ModalBackdrop>
	);
};

export type MenuContainerProps = Required<Pick<ModalBackdropProps, 'visible'>> & {
	onBackdropPress: ModalBackdropProps['onPress'];
	children?: ChildrenWithProps<ModalMenuItemProps>;
	bottom?: boolean;
};

const styles = StyleSheet.create({
	menuContainer: {
		width: '100%',
		maxWidth: 380,
		alignSelf: 'center',
	},
	bottom: {
		position: 'absolute',
		bottom: spacing(6),
	},
	menu: { borderRadius: spacing(3), padding: spacing() },
});
